<template lang="pug">
.content-center
  .overlay
  .back-btn.mb-2(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }} 
  template(v-if="$store.getters.language == 'cn'")
    cnContent
  template(v-else-if="$store.getters.language == 'vi'")
    viContent
  template(v-else-if="$store.getters.language == 'th'")
    thContent
  template(v-else-if="$store.getters.language == 'id'")
    idContent
  template(v-else-if="$store.getters.language == 'kr'")
    krContent
  template(v-else)
    enContent
</template>

<script>
import enContent from "@/components/mobile/rules/en/ufc";
import cnContent from "@/components/mobile/rules/cn/ufc";
import viContent from "@/components/mobile/rules/vi/ufc";
import thContent from "@/components/mobile/rules/th/ufc";
import idContent from "@/components/mobile/rules/id/ufc";
import krContent from "@/components/mobile/rules/kr/ufc";

export default {
  components: {
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {},
  mounted() {
    // Ensure page scrolls to top when component is mounted
    this.$nextTick(() => {
      const contentCenter = document.querySelector('.content-center');
      if (contentCenter) {
        contentCenter.scrollTop = 0;
      } else {
        window.scrollTo(0, 0);
      }
    });
  },
  methods: {
    back() {
      this.$router.push("/betting_rules");
    }
  }
};
</script>
